// extracted by mini-css-extract-plugin
module.exports = {"MoneyButton":"MoneyButton_MoneyButton__3o2XM"};